var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingDRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 61,
    viewBox: "0 0 65 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75350_87304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4316 58.0004H30.3116C16.7116 58.0004 0.311638 49.0404 0.311638 29.6804C0.311638 10.4803 14.2316 1.36035 29.1116 1.36035H51.4316V58.0004ZM41.3516 48.8804V10.4803H32.1516C19.8316 10.4803 10.8716 15.9203 10.8716 29.6804C10.8716 43.4403 21.1916 48.8804 33.8316 48.8804H41.3516Z",
    fill: "#52B3A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.998 1.7998L58.1113 6.7998L63.8848 6.7998L60.998 1.7998ZM60.998 58.7998L63.8848 53.7998L58.1113 53.7998L60.998 58.7998ZM60.498 6.2998L60.498 54.2998L61.498 54.2998L61.498 6.2998L60.498 6.2998Z",
    fill: "#F38D33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75350_87304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 60,
    fill: "white",
    transform: "translate(0.3125 0.360352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingDRing);
export default __webpack_public_path__ + "static/media/jobconfig-binding-dRing.2ac3d39f72c5dc5a56428b8998ddec2d.svg";
export { ForwardRef as ReactComponent };